/* eslint-disable */
// @ts-nocheck
/**
 * @fileoverview gRPC-Web generated client stub for worklayer.internal.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.19.1
// source: internal/job.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var shared_types_decimal_pb = require('../shared/types/decimal_pb.js')

var shared_types_interval_pb = require('../shared/types/interval_pb.js')

var internal_job_progression_pb = require('../internal/job_progression_pb.js')

var internal_question_input_value_pb = require('../internal/question_input_value_pb.js')

var internal_consultation_pb = require('../internal/consultation_pb.js')

var internal_job_scope_change_pb = require('../internal/job_scope_change_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.worklayer = {};
proto.worklayer.internal = {};
proto.worklayer.internal.v1 = require('./job_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.v1.JobServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.v1.JobServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.RenameJobRequest,
 *   !proto.worklayer.internal.v1.RenameJobResponse>}
 */
const methodDescriptor_JobService_RenameJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/RenameJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.RenameJobRequest,
  proto.worklayer.internal.v1.RenameJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.RenameJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.RenameJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.RenameJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.RenameJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.RenameJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.renameJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/RenameJob',
      request,
      metadata || {},
      methodDescriptor_JobService_RenameJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.RenameJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.RenameJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.renameJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/RenameJob',
      request,
      metadata || {},
      methodDescriptor_JobService_RenameJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest,
 *   !proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse>}
 */
const methodDescriptor_JobService_AddTeamMemberAsSupportingClient = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/AddTeamMemberAsSupportingClient',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest,
  proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse,
  /**
   * @param {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.addTeamMemberAsSupportingClient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/AddTeamMemberAsSupportingClient',
      request,
      metadata || {},
      methodDescriptor_JobService_AddTeamMemberAsSupportingClient,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.addTeamMemberAsSupportingClient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/AddTeamMemberAsSupportingClient',
      request,
      metadata || {},
      methodDescriptor_JobService_AddTeamMemberAsSupportingClient);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.RemoveSupportingClientRequest,
 *   !proto.worklayer.internal.v1.RemoveSupportingClientResponse>}
 */
const methodDescriptor_JobService_RemoveSupportingClient = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/RemoveSupportingClient',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.RemoveSupportingClientRequest,
  proto.worklayer.internal.v1.RemoveSupportingClientResponse,
  /**
   * @param {!proto.worklayer.internal.v1.RemoveSupportingClientRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.RemoveSupportingClientResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.RemoveSupportingClientRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.RemoveSupportingClientResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.RemoveSupportingClientResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.removeSupportingClient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/RemoveSupportingClient',
      request,
      metadata || {},
      methodDescriptor_JobService_RemoveSupportingClient,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.RemoveSupportingClientRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.RemoveSupportingClientResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.removeSupportingClient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/RemoveSupportingClient',
      request,
      metadata || {},
      methodDescriptor_JobService_RemoveSupportingClient);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.PlaceJobOnHoldRequest,
 *   !proto.worklayer.internal.v1.PlaceJobOnHoldResponse>}
 */
const methodDescriptor_JobService_PlaceJobOnHold = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/PlaceJobOnHold',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.PlaceJobOnHoldRequest,
  proto.worklayer.internal.v1.PlaceJobOnHoldResponse,
  /**
   * @param {!proto.worklayer.internal.v1.PlaceJobOnHoldRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.PlaceJobOnHoldResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.PlaceJobOnHoldRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.PlaceJobOnHoldResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.PlaceJobOnHoldResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.placeJobOnHold =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/PlaceJobOnHold',
      request,
      metadata || {},
      methodDescriptor_JobService_PlaceJobOnHold,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.PlaceJobOnHoldRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.PlaceJobOnHoldResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.placeJobOnHold =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/PlaceJobOnHold',
      request,
      metadata || {},
      methodDescriptor_JobService_PlaceJobOnHold);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ResumeJobRequest,
 *   !proto.worklayer.internal.v1.ResumeJobResponse>}
 */
const methodDescriptor_JobService_ResumeJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/ResumeJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ResumeJobRequest,
  proto.worklayer.internal.v1.ResumeJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ResumeJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ResumeJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ResumeJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ResumeJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ResumeJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.resumeJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/ResumeJob',
      request,
      metadata || {},
      methodDescriptor_JobService_ResumeJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ResumeJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ResumeJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.resumeJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/ResumeJob',
      request,
      metadata || {},
      methodDescriptor_JobService_ResumeJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ForfeitJobRequest,
 *   !proto.worklayer.internal.v1.ForfeitJobResponse>}
 */
const methodDescriptor_JobService_ForfeitJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/ForfeitJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ForfeitJobRequest,
  proto.worklayer.internal.v1.ForfeitJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ForfeitJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ForfeitJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ForfeitJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ForfeitJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ForfeitJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.forfeitJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/ForfeitJob',
      request,
      metadata || {},
      methodDescriptor_JobService_ForfeitJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ForfeitJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ForfeitJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.forfeitJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/ForfeitJob',
      request,
      metadata || {},
      methodDescriptor_JobService_ForfeitJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SearchJobsRequest,
 *   !proto.worklayer.internal.v1.SearchJobsResponse>}
 */
const methodDescriptor_JobService_SearchJobs = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/SearchJobs',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SearchJobsRequest,
  proto.worklayer.internal.v1.SearchJobsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SearchJobsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.SearchJobsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SearchJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.SearchJobsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.SearchJobsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.searchJobs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/SearchJobs',
      request,
      metadata || {},
      methodDescriptor_JobService_SearchJobs,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SearchJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.SearchJobsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.searchJobs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/SearchJobs',
      request,
      metadata || {},
      methodDescriptor_JobService_SearchJobs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.CloseJobRequest,
 *   !proto.worklayer.internal.v1.CloseJobResponse>}
 */
const methodDescriptor_JobService_CloseJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/CloseJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.CloseJobRequest,
  proto.worklayer.internal.v1.CloseJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.CloseJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.CloseJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.CloseJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.CloseJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.CloseJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.closeJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/CloseJob',
      request,
      metadata || {},
      methodDescriptor_JobService_CloseJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.CloseJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.CloseJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.closeJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/CloseJob',
      request,
      metadata || {},
      methodDescriptor_JobService_CloseJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.GetJobRequest,
 *   !proto.worklayer.internal.v1.Job>}
 */
const methodDescriptor_JobService_GetJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/GetJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.GetJobRequest,
  proto.worklayer.internal.v1.Job,
  /**
   * @param {!proto.worklayer.internal.v1.GetJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.Job.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.GetJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.Job)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.Job>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.getJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/GetJob',
      request,
      metadata || {},
      methodDescriptor_JobService_GetJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.GetJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.Job>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.getJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/GetJob',
      request,
      metadata || {},
      methodDescriptor_JobService_GetJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.BatchGetJobsRequest,
 *   !proto.worklayer.internal.v1.BatchGetJobsResponse>}
 */
const methodDescriptor_JobService_BatchGetJobs = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/BatchGetJobs',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.BatchGetJobsRequest,
  proto.worklayer.internal.v1.BatchGetJobsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.BatchGetJobsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.BatchGetJobsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.BatchGetJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.BatchGetJobsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.BatchGetJobsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.batchGetJobs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/BatchGetJobs',
      request,
      metadata || {},
      methodDescriptor_JobService_BatchGetJobs,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.BatchGetJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.BatchGetJobsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.batchGetJobs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/BatchGetJobs',
      request,
      metadata || {},
      methodDescriptor_JobService_BatchGetJobs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ListJobQuestionsRequest,
 *   !proto.worklayer.internal.v1.ListJobQuestionsResponse>}
 */
const methodDescriptor_JobService_ListJobQuestions = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/ListJobQuestions',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ListJobQuestionsRequest,
  proto.worklayer.internal.v1.ListJobQuestionsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ListJobQuestionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ListJobQuestionsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ListJobQuestionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ListJobQuestionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ListJobQuestionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.listJobQuestions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/ListJobQuestions',
      request,
      metadata || {},
      methodDescriptor_JobService_ListJobQuestions,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ListJobQuestionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ListJobQuestionsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.listJobQuestions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/ListJobQuestions',
      request,
      metadata || {},
      methodDescriptor_JobService_ListJobQuestions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ClaimJobRequest,
 *   !proto.worklayer.internal.v1.ClaimJobResponse>}
 */
const methodDescriptor_JobService_ClaimJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/ClaimJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ClaimJobRequest,
  proto.worklayer.internal.v1.ClaimJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ClaimJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ClaimJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ClaimJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ClaimJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ClaimJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.claimJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/ClaimJob',
      request,
      metadata || {},
      methodDescriptor_JobService_ClaimJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ClaimJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ClaimJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.claimJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/ClaimJob',
      request,
      metadata || {},
      methodDescriptor_JobService_ClaimJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ClaimConsultationJobRequest,
 *   !proto.worklayer.internal.v1.ClaimJobResponse>}
 */
const methodDescriptor_JobService_ClaimConsultationJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/ClaimConsultationJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ClaimConsultationJobRequest,
  proto.worklayer.internal.v1.ClaimJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ClaimConsultationJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ClaimJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ClaimConsultationJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ClaimJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ClaimJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.claimConsultationJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/ClaimConsultationJob',
      request,
      metadata || {},
      methodDescriptor_JobService_ClaimConsultationJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ClaimConsultationJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ClaimJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.claimConsultationJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/ClaimConsultationJob',
      request,
      metadata || {},
      methodDescriptor_JobService_ClaimConsultationJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.CopyJobRequest,
 *   !proto.worklayer.internal.v1.CopyJobResponse>}
 */
const methodDescriptor_JobService_CopyJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/CopyJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.CopyJobRequest,
  proto.worklayer.internal.v1.CopyJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.CopyJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.CopyJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.CopyJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.CopyJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.CopyJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.copyJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/CopyJob',
      request,
      metadata || {},
      methodDescriptor_JobService_CopyJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.CopyJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.CopyJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.copyJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/CopyJob',
      request,
      metadata || {},
      methodDescriptor_JobService_CopyJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.BulkCopyJobRequest,
 *   !proto.worklayer.internal.v1.BulkCopyJobResponse>}
 */
const methodDescriptor_JobService_BulkCopyJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/BulkCopyJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.BulkCopyJobRequest,
  proto.worklayer.internal.v1.BulkCopyJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.BulkCopyJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.BulkCopyJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.BulkCopyJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.BulkCopyJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.BulkCopyJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.bulkCopyJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/BulkCopyJob',
      request,
      metadata || {},
      methodDescriptor_JobService_BulkCopyJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.BulkCopyJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.BulkCopyJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.bulkCopyJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/BulkCopyJob',
      request,
      metadata || {},
      methodDescriptor_JobService_BulkCopyJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.CompleteTaskRequest,
 *   !proto.worklayer.internal.v1.CompleteTaskResponse>}
 */
const methodDescriptor_JobService_CompleteTask = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/CompleteTask',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.CompleteTaskRequest,
  proto.worklayer.internal.v1.CompleteTaskResponse,
  /**
   * @param {!proto.worklayer.internal.v1.CompleteTaskRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.CompleteTaskResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.CompleteTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.CompleteTaskResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.CompleteTaskResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.completeTask =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/CompleteTask',
      request,
      metadata || {},
      methodDescriptor_JobService_CompleteTask,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.CompleteTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.CompleteTaskResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.completeTask =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/CompleteTask',
      request,
      metadata || {},
      methodDescriptor_JobService_CompleteTask);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.UncompleteTaskRequest,
 *   !proto.worklayer.internal.v1.UncompleteTaskResponse>}
 */
const methodDescriptor_JobService_UncompleteTask = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/UncompleteTask',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.UncompleteTaskRequest,
  proto.worklayer.internal.v1.UncompleteTaskResponse,
  /**
   * @param {!proto.worklayer.internal.v1.UncompleteTaskRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UncompleteTaskResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.UncompleteTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UncompleteTaskResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UncompleteTaskResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.uncompleteTask =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/UncompleteTask',
      request,
      metadata || {},
      methodDescriptor_JobService_UncompleteTask,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.UncompleteTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UncompleteTaskResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.uncompleteTask =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/UncompleteTask',
      request,
      metadata || {},
      methodDescriptor_JobService_UncompleteTask);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.MakeCorrectionsRequest,
 *   !proto.worklayer.internal.v1.MakeCorrectionsResponse>}
 */
const methodDescriptor_JobService_MakeCorrections = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/MakeCorrections',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.MakeCorrectionsRequest,
  proto.worklayer.internal.v1.MakeCorrectionsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.MakeCorrectionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.MakeCorrectionsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.MakeCorrectionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.MakeCorrectionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.MakeCorrectionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.makeCorrections =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/MakeCorrections',
      request,
      metadata || {},
      methodDescriptor_JobService_MakeCorrections,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.MakeCorrectionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.MakeCorrectionsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.makeCorrections =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/MakeCorrections',
      request,
      metadata || {},
      methodDescriptor_JobService_MakeCorrections);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.CompleteInfoGatheringRequest,
 *   !proto.worklayer.internal.v1.CompleteInfoGatheringResponse>}
 */
const methodDescriptor_JobService_CompleteInfoGathering = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/CompleteInfoGathering',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.CompleteInfoGatheringRequest,
  proto.worklayer.internal.v1.CompleteInfoGatheringResponse,
  /**
   * @param {!proto.worklayer.internal.v1.CompleteInfoGatheringRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.CompleteInfoGatheringResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.CompleteInfoGatheringRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.CompleteInfoGatheringResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.CompleteInfoGatheringResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.completeInfoGathering =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/CompleteInfoGathering',
      request,
      metadata || {},
      methodDescriptor_JobService_CompleteInfoGathering,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.CompleteInfoGatheringRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.CompleteInfoGatheringResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.completeInfoGathering =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/CompleteInfoGathering',
      request,
      metadata || {},
      methodDescriptor_JobService_CompleteInfoGathering);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.RequestJobChampionProviderRequest,
 *   !proto.worklayer.internal.v1.RequestJobChampionProviderResponse>}
 */
const methodDescriptor_JobService_RequestChampionProvider = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobService/RequestChampionProvider',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.RequestJobChampionProviderRequest,
  proto.worklayer.internal.v1.RequestJobChampionProviderResponse,
  /**
   * @param {!proto.worklayer.internal.v1.RequestJobChampionProviderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.RequestJobChampionProviderResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.RequestJobChampionProviderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.RequestJobChampionProviderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.RequestJobChampionProviderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobServiceClient.prototype.requestChampionProvider =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/RequestChampionProvider',
      request,
      metadata || {},
      methodDescriptor_JobService_RequestChampionProvider,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.RequestJobChampionProviderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.RequestJobChampionProviderResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobServicePromiseClient.prototype.requestChampionProvider =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobService/RequestChampionProvider',
      request,
      metadata || {},
      methodDescriptor_JobService_RequestChampionProvider);
};


module.exports = proto.worklayer.internal.v1;

